import{createContext as r}from"react";var t=r();export default t;
//# sourceMappingURL=wizard-context.js.map
